import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() { }

  private data: any = {};

  setData(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getData(key: string): any {
    return localStorage.getItem(key);
  }

  clearData(key:string) {
    localStorage.setItem(key, "");
    localStorage.removeItem(key);

  }
}
